import Lara from "@/presets/lara";

export const anonymousAdvisingPresets = {
  ...Lara,
  inputtext: {
    ...Lara.inputtext,
    root: (args) => ({
      class: ["!rounded-full", ...Lara.inputtext.root(args).class],
    }),
  },
};
